import { getMLASupplementaryData } from "selectors";

export const getMLASupplementaryDataById = mlaSupplementaryDataId => state =>
  getMLASupplementaryData(state)[mlaSupplementaryDataId] || null;
